import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7973a0f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addedit-linked-practice-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Linked practices", -1))
const _hoisted_5 = {
  key: 0,
  class: "body-main has-indicator"
}
const _hoisted_6 = {
  key: 1,
  class: "body-main has-indicator"
}
const _hoisted_7 = { class: "body-main" }
const _hoisted_8 = { class: "ls-form" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Practice name", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  class: "autocomplete",
  style: {"flex":"0 0 100%"}
}
const _hoisted_12 = { class: "icon-hm" }
const _hoisted_13 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_14 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_15 = {
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_16 = ["innerHTML", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date of transfer", -1))
const _hoisted_21 = { class: "date-picker" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Create Investigation", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "By selecting the option you will be able to add an investigation.", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { class: "checkbox-button" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Yes, I would like to create an investigation.")
], -1))
const _hoisted_29 = { class: "controls mt-4" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_33 = {
  key: 0,
  class: "delete-transfer"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Delete linked practice", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Are you sure you want to delete the transfer?", -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[10] || (_cache[10] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.editMode ? 'Edit' : 'Transfer') + " " + _toDisplayString(_ctx.practiceName), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.loadingContent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_LoadingIndicator)
            ]))
          : (_ctx.errorLoadingContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_ErrorIndicator)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("form", _hoisted_8, [
                    _createElementVNode("fieldset", null, [
                      _hoisted_9,
                      _createElementVNode("div", null, _toDisplayString(_ctx.practiceName), 1),
                      _hoisted_10,
                      _createElementVNode("label", null, "Transfer " + _toDisplayString(_ctx.mode == 1 ? 'from' : 'to'), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          onKeydown: [
                            _cache[0] || (_cache[0] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                            _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                            _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                          ],
                          class: "searchField",
                          type: "text",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.search) = $event)),
                          placeholder: "Search practice name or ID"
                        }, null, 544), [
                          [_vModelText, _ctx.search]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "hidden",
                          id: "practice",
                          name: "practice",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.currentSelectedPractice) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.currentSelectedPractice]
                        ]),
                        _createElementVNode("span", _hoisted_12, [
                          (_ctx.isSearching)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                            : (_openBlock(), _createElementBlock("i", _hoisted_14))
                        ]),
                        _withDirectives(_createElementVNode("ul", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.practiceList, (practice, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                              innerHTML: _ctx.highlightWord(practice.firmId + ' - ' + (practice.branchId && practice.tradingName ? practice.name + ' - ' + practice.tradingName : practice.name)),
                              onClick: _withModifiers($event => (_ctx.selectPractice(practice)), ["prevent"])
                            }, null, 10, _hoisted_16))
                          }), 128))
                        ], 512), [
                          [_vShow, _ctx.isOpen]
                        ]),
                        (!_ctx.currentSelectedPractice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _hoisted_18,
                              _createTextVNode(" Mandatory field ")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_19,
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_v3_date_picker, {
                                class: "v3-date-picker",
                                modelValue: _ctx.effectiveDate,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.effectiveDate) = $event)),
                                style: {"padding":"1em"},
                                inputFormat: "dd-MM-yyyy"
                              }, null, 8, ["modelValue"]),
                              _hoisted_22
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (!_ctx.editMode)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_23,
                            _hoisted_24,
                            _hoisted_25,
                            _hoisted_26,
                            _createElementVNode("label", _hoisted_27, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.createInvestigation) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.createInvestigation]
                              ]),
                              _hoisted_28
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    class: "btn btn-default ml-1",
                    disabled: _ctx.submitting,
                    onClick: _cache[7] || (_cache[7] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
                  }, " Back ", 8, _hoisted_30),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
                    onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.saveLinkedPractice()), ["prevent","stop"]))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.editMode? 'Save changes' : 'Transfer practice'), 1),
                    _hoisted_32
                  ], 8, _hoisted_31),
                  (_ctx.submitting)
                    ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                        key: 0,
                        class: "loading-indicator",
                        showLoadingText: false
                      }))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createTextVNode(" Or "),
                      _createElementVNode("a", {
                        class: "link2",
                        onClick: _cache[9] || (_cache[9] = $event => (_ctx.showDeleteAlert = true))
                      }, "delete transfer")
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
      ]),
      _: 1
    }),
    (_ctx.showDeleteAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[13] || (_cache[13] = $event => (_ctx.showDeleteAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_34
          ]),
          body: _withCtx(() => [
            _hoisted_35
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[11] || (_cache[11] = $event => (_ctx.showDeleteAlert = false))
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.yesClicked && _ctx.yesClicked(...args)))
            }, "Delete")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}